import { render, staticRenderFns } from "./QuickTipsNoHistory.vue?vue&type=template&id=1d7b3c4d&"
import script from "./QuickTipsNoHistory.vue?vue&type=script&lang=js&"
export * from "./QuickTipsNoHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports